var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"clip",staticClass:"headerClip",style:({
  'clip-path': 'polygon(0 ' + _vm.top + 'px, 100% ' + _vm.top + 'px, 100% 100%, 0 100%)'
})},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }